<template>
  <b-container :fluid="true" class="wd-approval-tab">
    <b-row>
      <b-col cols="12">
        <ag-grid-vue class="ag-theme-balham wd-approval-tab__grid"
                     @selectionChanged="getSelectedIds"
                     :gridOptions="approvalTabGridOptions"
                     :columnDefs="grid.used_columns"
                     :rowData="grid.data" />
      </b-col>
      <b-col class="text-center">
        <wd-pagination
            :grid="grid"
            :limit="searchPayload.limit"
            :offset="searchPayload.offset"
            @pageChanged="fetchApprovalTab"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapGetters, mapState } from 'vuex'
import { gridMixins } from '@/mixins'
import WdPagination from '@/components/common/WdPagination'

export default {
  name: 'ApprovalTab',
  mixins: [gridMixins],
  components: {
    'ag-grid-vue': AgGridVue,
    WdPagination
  },
  computed: {
    ...mapGetters('invoicesApproval', ['approvalTabGridOptions']),
    ...mapState('invoicesApproval', ['grid', 'searchPayload'])
  },
  methods: {
    async fetchApprovalTab (params) {
      await this.$store.dispatch('invoicesApproval/loadApprovalTab', { params })
    },
    async getSelectedIds () {
      const api = this.approvalTabGridOptions.api
      const selected = api.getSelectedRows().map(el => el.id)
      await this.$store.dispatch('invoicesApproval/setSelected', selected)
    },
  }
}
</script>
<style lang="sass" scoped>
.wd-approval-tab
  &__btn-container
    text-align: right
  &__grid
    height: calc(100vh - 300px)
</style>


// WEBPACK FOOTER //
// src/components/common/invoices-approval/ApprovalTab.vue